import React from 'react';
import { Card, CardTitle, CardText, CardImg, CardImgOverlay } from 'seduo-ui';
const Example = (props) => (<div>
        <Card inverse>
            <CardImg width="100%" src="https://dummyimage.com/318x270/9fa4a8/fff.png" alt="Card image cap"/>
            <CardImgOverlay>
                <CardTitle>Card Title</CardTitle>
                <CardText>
                    This is a wider card with supporting text below as a natural lead-in to additional content. This
                    content is a little bit longer.
                </CardText>
                <CardText>
                    <small className="text-muted">Last updated 3 mins ago</small>
                </CardText>
            </CardImgOverlay>
        </Card>
    </div>);
export default Example;
